"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Adam Drda
 */


var ForecastChangeSupplierAgreementDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastChangeSupplierAgreementDTO, _DomainObject_1$Domai);

  function ForecastChangeSupplierAgreementDTO(supplierId, preferred, promoPurchasePrice, unitBackDiscount) {
    var _this;

    _classCallCheck(this, ForecastChangeSupplierAgreementDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeSupplierAgreementDTO).call(this));
    _this.supplierId = supplierId;
    _this.preferred = preferred;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.unitBackDiscount = unitBackDiscount;
    return _this;
  }

  _createClass(ForecastChangeSupplierAgreementDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ForecastChangeSupplierAgreementDTO(mat.supplierId, mat.preferred, mat.promoPurchasePrice, mat.unitBackDiscount);
    }
  }]);

  return ForecastChangeSupplierAgreementDTO;
}(DomainObject_1.DomainObject);

exports.ForecastChangeSupplierAgreementDTO = ForecastChangeSupplierAgreementDTO;

ForecastChangeSupplierAgreementDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastChangeSupplierAgreementDTO.name);
  return {
    supplierId: builder.str('supplierId'),
    preferred: builder.bool('preferred'),
    promoPurchasePrice: builder.data('promoPurchasePrice', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    unitBackDiscount: builder.data('unitBackDiscount', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })
  };
}();